export { default as default } from './KitSafeAreaProvider';
